import { render, staticRenderFns } from "./AllServices.vue?vue&type=template&id=baea7b30&"
import script from "./AllServices.vue?vue&type=script&lang=js&"
export * from "./AllServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports